// @ts-ignore
import React from "react";

import { useIntl } from "react-intl";

import { getLocalizedHref, useLocale } from "@/libraries/web-framework";
import { DropdownContent } from "@/templates/software/jira/service-management/jira-service-management-software-page/src/sections/software-jira-service-management-navbarv2";

export const FeaturesDropdown = () => {
    const locale = useLocale();
    const intl = useIntl();

    const allFeaturesLink = {
        text: intl.formatMessage({
            id: "jira.FeaturesDropdown.allFeatures",
            defaultMessage: "All Features"
        }),
        href: getLocalizedHref({
            href: "/software/jira/features",
            locale
        })
    };

    const featureLinks = [
        {
            text: intl.formatMessage({
                id: "jira.FeaturesDropdown.rovo",
                defaultMessage: "Rovo in Jira"
            }),
            href: getLocalizedHref({
                href: "/software/jira/ai",
                locale
            })
        }
    ];

    return (
        <DropdownContent
            orientation="column"
            contentSections={[
                {
                    links: [allFeaturesLink, ...featureLinks]
                }
            ]}
        />
    );
};
